/*
 * Manu AI — agent IA de création RXWEAR (section « ai-studio », 15/10/2026, v7)
 * ---------------------------------------------------------------
 * Accueil : sport (4 boutons) + idée libre avec exemples, ou « Importer mon logo ».
 *   Exemples : metafield rxwear_studio.examples (onglet Manu AI du back-office), chacun avec la vignette de son style ;
 *   à défaut, ceux de assets/ai-studio-i18n.js.
 * Création avec Manu :
 *   1. Manu (ChatGPT via /api/studio, action chat) pose jusqu'à 3 questions : répartition devant / dos,
 *      style tendance (3 vignettes proposées, liste GET ?action=styles), texte exact si besoin
 *   2. il dessine un VRAI logo pour chaque face choisie (action logo) : le dos d'abord (28 × 32 cm),
 *      puis le devant (bandeau 28 × 12 cm) à partir du dos, pour garder le même univers
 *   3. éditeur devant / dos : déplacer, redimensionner dans la zone d'impression, remplacer par un fichier,
 *      couleur du vêtement (variantes Shopify), retouches en un clic ou en texte libre
 * Ensuite : choix du vêtement → récapitulatif → fiche produit (?rx_studio=1). Chaque face est convertie
 * en SVG à la taille réelle (position et taille comprises) et rangée dans IndexedDB (rxStudio/logo, v2) ;
 * assets/ai-studio-handoff.js la dépose dans le template Teeinblue « Votre logo » / « Ajout logo ».
 * Sans endpoint (ou 501) : logos simulés dans le navigateur (0 €).
 */
(function () {
  'use strict';

  var I18N = window.RX_AIS_I18N || {};

  var SPORTS = ['running', 'trail', 'crossfit', 'hyrox', 'fitness', 'other'];
  var NICHE_OF = { running: 'running', trail: 'running', crossfit: 'cf', hyrox: 'cf', fitness: 'cf', other: 'cf' };
  var NICHE_TAGS = ['running', 'crossfit', 'cf', 'ia'];
  var TAG_NAMES = { minimalist: 'Minimaliste', wavy: 'Wavy', bold: 'Bold', beast: 'Beast mode', teddy: 'Teddy', 'teddy dark': 'Teddy dark', flower: 'Flower', slogan: 'Slogan', 'oversize text': 'Oversize XXL', grafiti: 'Graffiti', number: 'Numéro', finisher: 'Finisher' };
  var BLOCKED = /\b(nike|adidas|puma|reebok|under ?armou?r|asics|hoka|lululemon|gymshark|disney|marvel|pixar|pok[eé]mon|mickey|simpsons?|naruto|one ?piece|dragon ?ball|starbucks|coca|red ?bull|mario|spider-?man|batman|superman|gta)\b/i;
  var FACES = ['front', 'back'];

  // Silhouettes (viewBox 400×400) et cadre de la zone d'impression sur le vêtement [x, y, largeur]
  var SHAPES = {
    tee:      { d: 'M146 54c14 16 94 16 108 0l70 30-22 64-34-12v214H132V136l-34 12-22-64z', zone: [140, 120, 120] },
    oversize: { d: 'M140 54c16 16 104 16 120 0l86 36-24 78-42-14v206H120V156l-42 14-24-78z', zone: [134, 124, 132] },
    tank:     { d: 'M160 54c6 44 74 44 80 0l26 6c-4 36 4 62 24 80v214H110V140c20-18 28-44 24-80z', zone: [146, 132, 108] },
    crop:     { d: 'M146 54c14 16 94 16 108 0l70 30-22 64-34-12v118H132V136l-34 12-22-64z', zone: [140, 118, 120] }
  };
  // Zones d'impression (cm)
  var SIZES = { front: [28, 12], back: [28, 32] };

  var IC = {
    arrow: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    redo: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7"/><path d="M21 4v5h-5"/></svg>',
    up: '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 16V4M7 9l5-5 5 5M5 20h14"/></svg>'
  };

  /* ---------- Outils ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmt(s, o) { return String(s).replace(/\{(\w+)\}/g, function (_, k) { return o[k] != null ? o[k] : ''; }); }
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem(k)); sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function addParam(url, p) { return url + (url.indexOf('?') > -1 ? '&' : '?') + p; }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function idbPut(key, val) {
    return new Promise(function (res, rej) {
      if (!window.indexedDB) return rej(new Error('no idb'));
      var rq = indexedDB.open('rxStudio', 1);
      rq.onupgradeneeded = function () { rq.result.createObjectStore('kv'); };
      rq.onerror = function () { rej(rq.error); };
      rq.onsuccess = function () {
        var tx = rq.result.transaction('kv', 'readwrite');
        tx.objectStore('kv').put(val, key);
        tx.oncomplete = function () { rq.result.close(); res(); };
        tx.onerror = function () { rej(tx.error); };
      };
    });
  }
  function loadImg(src) { return new Promise(function (res, rej) { var i = new Image(); i.onload = function () { res(i); }; i.onerror = rej; i.src = src; }); }
  function readAs(file, how) { return new Promise(function (res, rej) { var r = new FileReader(); r.onload = function () { res(r.result); }; r.onerror = rej; r[how](file); }); }
  // Image (fond transparent) → PNG recadré au contenu
  function trimPng(src) {
    return loadImg(src).then(function (img) {
      var w = img.naturalWidth || 1000, h = img.naturalHeight || 1000, c = document.createElement('canvas');
      c.width = w; c.height = h;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data, x0 = w, y0 = h, x1 = -1, y1 = -1;
      for (var y = 0; y < h; y++) for (var x = 0; x < w; x++) if (d[(y * w + x) * 4 + 3] > 8) { if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y; }
      if (x1 < 0) { x0 = 0; y0 = 0; x1 = w - 1; y1 = h - 1; }
      var cw = x1 - x0 + 1, ch = y1 - y0 + 1, t = document.createElement('canvas');
      t.width = cw; t.height = ch; t.getContext('2d').drawImage(c, x0, y0, cw, ch, 0, 0, cw, ch);
      return { png: t.toDataURL('image/png'), w: cw, h: ch };
    });
  }
  // Fond blanc (ou presque) relié aux bords → transparent ; le blanc à l'intérieur du logo est gardé
  function clearWhite(src) {
    return loadImg(src).then(function (img) {
      var w = img.naturalWidth, h = img.naturalHeight, c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0);
      var im = ctx.getImageData(0, 0, w, h), d = im.data, seen = new Uint8Array(w * h), stack = [];
      var white = function (i) { var o = i * 4; return d[o + 3] > 0 && d[o] > 232 && d[o + 1] > 232 && d[o + 2] > 232; };
      for (var x = 0; x < w; x++) { stack.push(x, (h - 1) * w + x); }
      for (var y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
      while (stack.length) {
        var i = stack.pop(); if (seen[i] || !white(i)) continue;
        seen[i] = 1; d[i * 4 + 3] = 0;
        var px = i % w;
        if (px > 0) stack.push(i - 1); if (px < w - 1) stack.push(i + 1);
        if (i >= w) stack.push(i - w); if (i < w * (h - 1)) stack.push(i + w);
      }
      ctx.putImageData(im, 0, 0);
      return c.toDataURL('image/png');
    });
  }
  function hasAlpha(src) {
    return loadImg(src).then(function (img) {
      var w = Math.min(img.naturalWidth, 400), h = Math.round(img.naturalHeight * w / img.naturalWidth), c = document.createElement('canvas'); c.width = w; c.height = h;
      var ctx = c.getContext('2d'); ctx.drawImage(img, 0, 0, w, h);
      var d = ctx.getImageData(0, 0, w, h).data;
      for (var i = 3; i < d.length; i += 4) if (d[i] < 250) return true;
      return false;
    });
  }
  // Rectangle du logo dans la zone (cm) : taille « ajustée » × k, centre (x, y) normalisé, toujours dans la zone
  function placeRect(face, side, pos) {
    var S = SIZES[side], W = S[0], H = S[1], r = face && face.w && face.h ? face.w / face.h : (side === 'back' ? 0.94 : 2.37);
    var iw = W, ih = W / r;
    if (ih > H) { ih = H; iw = H * r; }
    var k = pos ? clamp(pos.k, 0.2, 1) : 1, w = iw * k, h = ih * k;
    var cx = clamp((pos ? pos.x : 0.5) * W, w / 2, W - w / 2), cy = clamp((pos ? pos.y : 0.5) * H, h / 2, H - h / 2);
    return { x: cx - w / 2, y: cy - h / 2, w: w, h: h, W: W, H: H };
  }
  // Fichier d'impression : SVG à la taille réelle de la zone, logo à sa place (vectoriel conservé si possible)
  function printSvg(face, side, pos) {
    var R = placeRect(face, side, pos), head = '<?xml version="1.0" encoding="UTF-8"?>\n<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="' + R.W + 'cm" height="' + R.H + 'cm" viewBox="0 0 ' + R.W + ' ' + R.H + '">\n';
    var box = ' x="' + R.x.toFixed(3) + '" y="' + R.y.toFixed(3) + '" width="' + R.w.toFixed(3) + '" height="' + R.h.toFixed(3) + '"';
    if (face.svg && face.vb) {
      return head + '  <svg' + box + ' viewBox="' + face.vb + '" preserveAspectRatio="xMidYMid meet">' + face.inner + '</svg>\n</svg>\n';
    }
    var png = face.view || face.src;
    return head + '  <image' + box + ' href="' + png + '" xlink:href="' + png + '" preserveAspectRatio="none"/>\n</svg>\n';
  }
  function dpiOf(face, side, pos) { var R = placeRect(face, side, pos); return Math.round((face.w || 0) / (R.w / 2.54)); }
  function shortTitle(t) { return String(t || '').split(' (')[0].replace(/\s+À PERSONNALISER$/i, ''); }
  function niceName(t) { var x = shortTitle(t); return x.charAt(0) + x.slice(1).toLowerCase(); }
  function colorKey(n) { return String(n || '').trim().toLowerCase(); }
  function garment(hex) {
    var h = String(hex || '#1d1d1d').replace('#', ''); if (h.length === 3) h = h.replace(/(.)/g, '$1$1');
    var r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
    var dark = (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.55;
    return { fill: '#' + h, line: dark ? 'rgba(0,0,0,.55)' : '#d8cdb9', collar: dark ? 'rgba(255,255,255,.18)' : 'rgba(0,0,0,.12)', ink: dark ? '#ffffff' : '#171717' };
  }
  // Texte à écrire dans le logo : entre guillemets dans l'idée (« BEAR & WOLF », "Team Lou")
  function quotedText(x) { var m = String(x).match(/[«“"„]\s*([^»”"“]{1,40}?)\s*[»”"“]/); return m ? m[1] : null; }

  /* ---------- Section ---------- */
  function Studio(root) {
    this.root = root;
    this.loc = root.getAttribute('data-locale') || 'fr';
    this.t = I18N[this.loc] || I18N.en || I18N.fr;
    this.endpoint = root.getAttribute('data-endpoint') || '';
    this.maxRuns = parseInt(root.getAttribute('data-max-sketch'), 10) || 3;
    this.designs = this.json('[data-ais-designs]');
    this.supports = this.json('[data-ais-supports]');
    this.exData = this.json('[data-ais-examples]');
    this.styleImgs = this.json('[data-ais-style-imgs]');
    this.dialog = root.querySelector('[data-ais-dialog]');
    this.thread = root.querySelector('[data-ais-thread]');
    this.quick = root.querySelector('[data-ais-quick]');
    this.replyField = root.querySelector('[data-ais-reply-field]');
    this.form = root.querySelector('[data-ais-start]');
    this.tokensEl = root.querySelector('[data-ais-tokens]');
    this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.paint();
    this.bind();
    this.placeIntro();
    this.setupLauncher();
  }
  Studio.prototype.json = function (sel) { try { return JSON.parse(this.root.querySelector(sel).textContent) || []; } catch (e) { return []; } };

  /* En-tête : sport + idée libre */
  var HERO_NICHES = ['fitness', 'crossfit', 'hyrox', 'running'];
  Studio.prototype.paint = function () {
    var t = this.t;
    this.root.querySelectorAll('[data-i18n]').forEach(function (el) { var v = t[el.getAttribute('data-i18n')]; if (typeof v === 'string') el.textContent = v; });
    this.replyField.placeholder = t.composer_ph;
    this.ideaField = this.root.querySelector('[data-ais-idea]');
    this.promptsEl = this.root.querySelector('[data-ais-prompts]');
    this.stripEl = this.root.querySelector('[data-ais-strip]');
    // Sport de départ : ?sport= (lien pub) > dernier choix de la visite > CrossFit
    var q = (location.search.match(/[?&]sport=([a-z]+)/i) || [])[1];
    q = q ? q.toLowerCase() : null;
    if (q === 'trail') q = 'running';
    this.setNiche(HERO_NICHES.indexOf(q) > -1 ? q : (HERO_NICHES.indexOf(store('aisNiche')) > -1 ? store('aisNiche') : 'crossfit'), true);
  };
  // Exemples du sport : [libellé, phrase, vignette du style] (back-office d'abord, sinon textes du thème)
  Studio.prototype.exList = function (k) {
    var loc = this.loc, imgs = this.styleImgs || {}, n = this.exData && this.exData.niches && this.exData.niches[k];
    if (n && n.length) return n.map(function (e) {
      return [(e.label && (e.label[loc] || e.label.fr)) || '', (e.text && (e.text[loc] || e.text.fr)) || '', (e.style && imgs[e.style]) || null];
    }).filter(function (x) { return x[0] && x[1]; });
    return ((this.t.niches || {})[k] || { ex: [] }).ex || [];
  };
  Studio.prototype.setNiche = function (k, quiet) {
    var t = this.t, n = (t.niches || {})[k] || { ph: '', ex: [] }, ex = this.exList(k);
    this.heroNiche = k;
    if (!quiet) store('aisNiche', k);
    this.root.querySelectorAll('[data-ais-niches] [data-niche]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-niche') === k ? 'true' : 'false'); });
    if (this.ideaField) this.ideaField.placeholder = n.ph;
    if (this.promptsEl) this.promptsEl.innerHTML = ex.map(function (x, i) {
      return '<button type="button" class="ais-chip' + (x[2] ? ' ais-chip--img' : '') + '" data-ex="' + i + '">' + (x[2] ? '<img src="' + esc(sized(x[2], 80)) + '" alt="" width="30" height="30" loading="lazy">' : '') + esc(x[0]) + '</button>';
    }).join('');
    // Designs établis : uniquement ceux du sport (limite data-max)
    if (this.stripEl) {
      var want = NICHE_OF[k], max = parseInt(this.stripEl.getAttribute('data-max'), 10) || 10, shown = 0;
      this.stripEl.querySelectorAll('li[data-niche]').forEach(function (li) {
        var ok = li.getAttribute('data-niche') === want && shown < max;
        if (ok) shown++;
        li.hidden = !ok;
      });
    }
  };
  // Mobile : titre + accroche en bas de la vidéo hero (bloc « Hero video mobile »), à la place de son texte
  Studio.prototype.placeIntro = function () {
    var intro = this.root.querySelector('[data-ais-intro]'), home = intro && intro.parentNode;
    var hero = document.querySelector('[class*="ai-hero-video-content-"]');
    if (!intro || !hero) return;
    var spot = document.createElement('div'); spot.className = 'ais-intro-spot'; spot.hidden = true;
    home.insertBefore(spot, intro);
    var mq = window.matchMedia('(max-width: 749px)');
    var place = function () {
      if (mq.matches && getComputedStyle(hero).display !== 'none') {
        hero.classList.add('ais-in-video'); hero.appendChild(intro); intro.classList.add('ais-intro--video');
      } else {
        hero.classList.remove('ais-in-video'); home.insertBefore(intro, spot); intro.classList.remove('ais-intro--video');
      }
    };
    place();
    if (mq.addEventListener) mq.addEventListener('change', place); else if (mq.addListener) mq.addListener(place);
  };

  Studio.prototype.bind = function () {
    var self = this, root = this.root;
    if (this.form) this.form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = self.ideaField ? self.ideaField.value.trim() : '';
      if (!v) { var ex = self.exList(self.heroNiche)[0]; if (ex && self.ideaField) { self.ideaField.value = ex[1]; self.ideaField.focus(); } return; }
      self.open({ path: 'story', idea: v });
    });
    // Fichier du visiteur : accueil (« Importer mon logo ») ou éditeur (une face)
    this.ownInput = root.querySelector('[data-ais-own]');
    if (this.ownInput) this.ownInput.addEventListener('change', function () {
      var f = self.ownInput.files && self.ownInput.files[0]; self.ownInput.value = '';
      if (f) self.ownFile(f, 'front', true);
    });
    root.addEventListener('change', function (e) {
      var inp = e.target.closest && e.target.closest('[data-face-file]'); if (!inp) return;
      var f = inp.files && inp.files[0]; inp.value = '';
      if (f) self.ownFile(f, self.s.edit, false);
    });
    root.querySelectorAll('[data-ais-niches] [data-niche]').forEach(function (b) {
      b.addEventListener('click', function () { self.setNiche(b.getAttribute('data-niche')); });
    });
    if (this.promptsEl) this.promptsEl.addEventListener('click', function (e) {
      var b = e.target.closest('[data-ex]'); if (!b || !self.ideaField) return;
      var ex = self.exList(self.heroNiche)[+b.getAttribute('data-ex')];
      if (!ex) return;
      self.ideaField.value = ex[1]; self.ideaField.focus();
      var L = ex[1].length; try { self.ideaField.setSelectionRange(L, L); } catch (err) {}
    });
    if (this.ideaField) this.ideaField.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) { e.preventDefault(); if (self.form.requestSubmit) self.form.requestSubmit(); else self.form.dispatchEvent(new Event('submit', { cancelable: true })); }
    });
    root.querySelectorAll('[data-ais-design]').forEach(function (b) {
      b.addEventListener('click', function () { var d = self.designs[+b.getAttribute('data-ais-design')]; if (d) self.open({ path: 'design', design: d }); });
    });
    root.querySelector('[data-ais-close]').addEventListener('click', function () { self.dialog.close(); });
    root.querySelector('[data-ais-restart]').addEventListener('click', function () { self.dialog.close(); self.toHero(); });
    this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.dialog.close(); });
    this.dialog.addEventListener('close', function () { document.documentElement.style.overflow = ''; if (self.returnFocus) self.returnFocus.focus({ preventScroll: true }); });
    this.quick.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || self.busy) return;
      self.command(b.getAttribute('data-cmd'), b.getAttribute('data-value'), b.textContent);
    });
    root.querySelector('[data-ais-reply]').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = self.replyField.value.trim(); if (!v || self.busy) return;
      self.replyField.value = '';
      self.freeText(v);
    });
    this.thread.addEventListener('click', function (e) {
      var el = e.target.closest('[data-act]'); if (!el || self.busy) return;
      var act = el.getAttribute('data-act'), s = self.s;
      if (act === 'pick-design') { var d = self.designs[+el.getAttribute('data-i')]; self.user(d.t); s.path = 'design'; s.design = d; s.niche = d.niche; self.lockThread(); self.resultEl = null; self.updateTokens(); self.flow(); }
      else if (act === 'pick-support') { var sp = self.supports[+el.getAttribute('data-i')]; self.user(shortTitle(sp.t)); s.support = sp; self.lockThread(); self.flow(); }
      else if (act === 'color') { self.setColor(el.getAttribute('data-c')); }
      else if (act === 'pick-style') { var lb = el.getAttribute('data-l'); s.style = el.getAttribute('data-k'); self.user(lb); self.lockThread(); self.quick.innerHTML = ''; self.askManu(lb); }
      else if (act === 'edit-face') { s.edit = el.getAttribute('data-v'); self.renderResult(); }
      else if (act === 'edit-center') { s.pos[s.edit].x = 0.5; s.pos[s.edit].y = 0.5; self.renderResult(); }
      else if (act === 'face-clear') { s.faces[s.edit] = null; self.renderResult(); }
      else if (act === 'face-bg') { var f = s.faces[s.edit]; f.clean = !f.clean; self.prepOwn(f).then(function () { self.renderResult(); }); }
      else if (act === 'face-redo') { self.user(fmt(self.t.redo_face, { side: self.t.sides[s.edit].toLowerCase() })); self.lockThread(); self.resultEl = null; self.generateFaces([s.edit], true); }
      else if (act === 'keep') {
        if (!s.faces.front && !s.faces.back) { self.bot(esc(self.t.nothing_to_keep)); return; }
        self.user(self.t.keep); self.lockThread(); self.resultEl = null;
        self.saveFaces().then(function () { s.designOk = true; self.flow(); });
      }
      else if (act === 'handoff') { self.handoff(); }
    });
    // Glisser le logo dans la zone d'impression (souris, doigt, flèches du clavier)
    this.thread.addEventListener('pointerdown', function (e) {
      var img = e.target.closest('[data-drag]'); if (!img) return;
      var R = img.parentNode.getBoundingClientRect(), s = self.s, side = s.edit, p = s.pos[side];
      var S = SIZES[side], start = { x: e.clientX, y: e.clientY, px: p.x, py: p.y };
      e.preventDefault(); img.setPointerCapture(e.pointerId);
      var move = function (ev) {
        p.x = start.px + (ev.clientX - start.x) / R.width;
        p.y = start.py + (ev.clientY - start.y) / R.height;
        var Q = placeRect(s.faces[side], side, p);
        p.x = (Q.x + Q.w / 2) / S[0]; p.y = (Q.y + Q.h / 2) / S[1];
        self.placeImg(img, side);
      };
      var up = function () { img.removeEventListener('pointermove', move); img.removeEventListener('pointerup', up); img.removeEventListener('pointercancel', up); self.refreshMock(); };
      img.addEventListener('pointermove', move); img.addEventListener('pointerup', up); img.addEventListener('pointercancel', up);
    });
    this.thread.addEventListener('input', function (e) {
      var r = e.target.closest('[data-size]'); if (!r) return;
      var s = self.s; s.pos[s.edit].k = parseInt(r.value, 10) / 100;
      var img = self.resultEl && self.resultEl.querySelector('[data-drag]'); if (img) self.placeImg(img, s.edit);
      self.refreshMock(); self.refreshQuality();
    });
    this.thread.addEventListener('keydown', function (e) {
      var img = e.target.closest('[data-drag]'); if (!img) return;
      var d = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] }[e.key]; if (!d) return;
      e.preventDefault();
      var s = self.s, p = s.pos[s.edit], S = SIZES[s.edit]; p.x += d[0] * 0.02; p.y += d[1] * 0.02;
      var Q = placeRect(s.faces[s.edit], s.edit, p);
      p.x = (Q.x + Q.w / 2) / S[0]; p.y = (Q.y + Q.h / 2) / S[1];
      self.placeImg(img, s.edit); self.refreshMock();
    });
  };
  Studio.prototype.toHero = function () {
    var f = this.ideaField; if (!f) return;
    this.root.scrollIntoView({ behavior: this.reduce ? 'auto' : 'smooth', block: 'start' });
    setTimeout(function () { f.focus({ preventScroll: true }); }, 400);
  };

  /* ---------- Ouverture / état ---------- */
  Studio.prototype.open = function (seed) {
    this.returnFocus = document.activeElement;
    this.reset();
    seed = seed || {};
    var s = this.s;
    s.path = seed.path || 'story';
    s.sport = this.heroNiche || 'crossfit'; s.niche = NICHE_OF[s.sport];
    if (seed.design) { s.design = seed.design; s.niche = seed.design.niche; this.user(seed.design.t); }
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal(); else this.dialog.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    this.updateTokens();
    if (seed.idea) {
      this.user(seed.idea);
      if (BLOCKED.test(seed.idea.toLowerCase())) { this.refuse(); return; }
      s.idea = seed.idea; s.logoText = quotedText(seed.idea);
      this.askManu(seed.idea);
    } else if (!seed.own) this.flow();
  };
  Studio.prototype.reset = function () {
    this.run = (this.run || 0) + 1; this.busy = false; this.resultEl = null; this.stopLoader();
    this.s = { path: null, sport: null, niche: null, idea: null, logoText: null, noText: false, style: null, goal: null, sides: null, frontDesc: null, backDesc: null,
      faces: { front: null, back: null }, pos: { front: { x: 0.5, y: 0.5, k: 1 }, back: { x: 0.5, y: 0.5, k: 1 } }, edit: 'front',
      questions: 0, history: [], designOk: false, design: null, support: null, color: 'noir', pending: null, tag: 'all', logo: null };
    this.replyField.placeholder = this.t.composer_ph;
    this.thread.innerHTML = ''; this.quick.innerHTML = '';
    this.updateTokens(); this.setStep('design');
  };
  Studio.prototype.setStep = function (step) {
    var order = ['design', 'support', 'custom'], idx = order.indexOf(step);
    this.root.querySelectorAll('[data-ais-steps] li').forEach(function (li) {
      var i = order.indexOf(li.getAttribute('data-step'));
      li.setAttribute('data-state', i < idx ? 'done' : i === idx ? 'current' : 'todo');
      if (i === idx) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
  };
  // Créations offertes par visite (une création = les faces dessinées en une fois)
  Studio.prototype.left = function () { return Math.max(0, this.maxRuns - (store('aisRuns') || 0)); };
  Studio.prototype.updateTokens = function () {
    var show = this.s && this.s.path === 'story';
    this.tokensEl.hidden = !show;
    if (show) this.tokensEl.textContent = fmt(this.t.tokens, { n: this.left() });
  };
  // Une fois un choix fait, les boutons des anciens messages ne sont plus actifs
  Studio.prototype.lockThread = function () {
    this.thread.querySelectorAll('[data-act]:not([data-act="color"]):not([data-act="handoff"])').forEach(function (b) { b.disabled = true; b.removeAttribute('data-act'); b.setAttribute('aria-disabled', 'true'); });
    this.thread.querySelectorAll('[data-drag], [data-size], [data-face-file]').forEach(function (el) { el.removeAttribute('data-drag'); el.removeAttribute('data-size'); el.removeAttribute('data-face-file'); el.disabled = true; });
  };

  /* ---------- Messages ---------- */
  Studio.prototype.scroll = function () { var th = this.thread; requestAnimationFrame(function () { th.scrollTo({ top: th.scrollHeight, behavior: 'smooth' }); }); };
  Studio.prototype.user = function (text) {
    var d = document.createElement('div'); d.className = 'ais-msg ais-msg--user'; d.innerHTML = '<p>' + esc(text) + '</p>';
    this.thread.appendChild(d); this.scroll();
  };
  Studio.prototype.bot = function (html, wide) {
    var self = this, run = this.run;
    return new Promise(function (res) {
      self.busy = true;
      var typing = document.createElement('div'); typing.className = 'ais-typing'; typing.setAttribute('aria-hidden', 'true');
      typing.innerHTML = '<span></span><span></span><span></span>';
      self.thread.appendChild(typing); self.scroll();
      setTimeout(function () {
        typing.remove();
        if (run !== self.run) return; // conversation recommencée entre-temps : on abandonne cette suite
        var d = document.createElement('div'); d.className = 'ais-msg ais-msg--bot' + (wide ? ' ais-msg--wide' : '');
        d.innerHTML = wide ? html : '<p>' + html + '</p>';
        self.thread.appendChild(d); self.scroll(); self.busy = false; res(d);
      }, self.reduce ? 0 : 380);
    });
  };
  Studio.prototype.chips = function (opts) {
    this.quick.innerHTML = (opts || []).map(function (o) {
      return '<button type="button" class="ais-chip' + (o.ghost ? ' ais-chip--ghost' : '') + '"' + (o.cmd ? ' data-cmd="' + esc(o.cmd) + '"' : '') + (o.v != null ? ' data-value="' + esc(o.v) + '"' : '') + (o.on ? ' aria-pressed="true"' : '') + '>' + esc(o.l) + '</button>';
    }).join('');
  };
  Studio.prototype.typing = function (on) {
    if (this.typingEl) { this.typingEl.remove(); this.typingEl = null; }
    if (!on) return;
    var t = document.createElement('div'); t.className = 'ais-typing'; t.setAttribute('aria-hidden', 'true');
    t.innerHTML = '<span></span><span></span><span></span>';
    this.thread.appendChild(t); this.typingEl = t; this.scroll();
  };
  Studio.prototype.refuse = function () { var self = this; this.s.idea = null; this.bot(esc(this.t.refused)).then(function () { self.s.pending = 'idea'; }); };

  /* ---------- Chargement (logo en cours de dessin, fichier en préparation) ---------- */
  Studio.prototype.startLoader = function (label, steps) {
    var t = this.t, el = document.createElement('div');
    el.className = 'ais-msg ais-msg--wide';
    el.innerHTML = '<div class="ais-loader" role="status" aria-live="polite">' +
      '<div class="ais-loader__shirts" aria-hidden="true">' + FACES.map(function (f) {
        return '<span class="ais-loader__shirt" data-f="' + f + '"><svg viewBox="40 40 320 330"><path d="' + SHAPES.tee.d + '"/></svg><i></i><b>' + esc(t.sides[f]) + '</b></span>';
      }).join('') + '</div>' +
      '<p class="ais-loader__label" data-l>' + esc(label) + '</p>' +
      '<div class="ais-loader__bar"><span data-bar></span></div>' +
      '<p class="ais-loader__tip" data-tip>' + esc((t.loading_tips || [''])[0]) + '</p></div>';
    this.thread.appendChild(el); this.scroll();
    var lo = this.loader = { el: el, steps: steps || 1, step: 0, tip: 0, t1: Date.now() }, self = this, per = 26000;
    var bar = el.querySelector('[data-bar]'), tipEl = el.querySelector('[data-tip]');
    lo.timer = setInterval(function () {
      var p = Math.min(0.96, (lo.step + Math.min(0.92, (Date.now() - lo.t1) / per)) / lo.steps);
      bar.style.width = (p * 100).toFixed(1) + '%';
    }, 250);
    lo.tipTimer = setInterval(function () { var tips = self.t.loading_tips || []; if (!tips.length) return; lo.tip = (lo.tip + 1) % tips.length; tipEl.textContent = tips[lo.tip]; }, 4500);
    return lo;
  };
  Studio.prototype.loaderStep = function (label, face, i) {
    var lo = this.loader; if (!lo) return;
    lo.step = i; lo.t1 = Date.now();
    lo.el.querySelector('[data-l]').textContent = label + (lo.steps > 1 ? ' (' + (i + 1) + '/' + lo.steps + ')' : '');
    lo.el.querySelectorAll('.ais-loader__shirt').forEach(function (s) { s.classList.toggle('is-on', s.getAttribute('data-f') === face); });
  };
  Studio.prototype.stopLoader = function () {
    var lo = this.loader; if (!lo) return;
    clearInterval(lo.timer); clearInterval(lo.tipTimer); lo.el.remove(); this.loader = null;
  };

  /* ---------- Manu : questions utiles avant de dessiner ---------- */
  Studio.prototype.askManu = function (text) {
    var self = this, s = this.s, run = this.run;
    s.history.push({ role: 'user', content: text });
    if (!this.endpoint) return this.localManu();
    this.busy = true; this.typing(true);
    fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({
      action: 'chat', locale: this.loc, messages: s.history.slice(-10),
      known: { sport: s.sport, idea: s.idea, logo_text: s.logoText, style: s.style, sides: s.sides, questions: s.questions }
    }) })
      .then(function (r) { if (!r.ok) { var e = new Error(r.status); e.status = r.status; throw e; } return r.json(); })
      .then(function (j) {
        if (run !== self.run) return;
        self.typing(false); self.busy = false;
        if (j.blocked) { self.refuse(); return; }
        if (j.sport && SPORTS.indexOf(j.sport) > -1) { s.sport = j.sport; s.niche = NICHE_OF[j.sport]; }
        if (j.logo_text && !s.noText) s.logoText = j.logo_text;
        if (j.style) s.style = j.style;
        if (j.goal) s.goal = j.goal;
        if (j.sides) s.sides = j.sides;
        if (j.front_desc) s.frontDesc = j.front_desc;
        if (j.back_desc) s.backDesc = j.back_desc;
        if (j.reply) s.history.push({ role: 'assistant', content: j.reply });
        var asks = !j.ready && j.asking && s.questions < 3;
        (j.reply ? self.bot(esc(j.reply)) : Promise.resolve()).then(function () {
          if (asks) { s.questions++; self.askChips(j.asking, j.style_options); return; }
          self.generateFaces(self.facesToDraw());
        });
      })
      .catch(function () { if (run !== self.run) return; self.typing(false); self.busy = false; self.localManu(); });
  };
  // Sans IA : une seule question (devant / dos), puis on dessine
  Studio.prototype.localManu = function () {
    var self = this, s = this.s;
    if (!s.sides && s.questions < 1) { s.questions++; this.bot(esc(this.t.q_sides)).then(function () { self.askChips('sides'); }); return; }
    this.generateFaces(this.facesToDraw());
  };
  Studio.prototype.askChips = function (asking, styleKeys) {
    var t = this.t, o = t.sides_opts || {};
    this.s.pending = 'manu';
    if (asking === 'style') { this.showStyles(styleKeys); return; }
    if (asking === 'sides') this.chips([{ cmd: 'sides', v: 'both', l: o.both }, { cmd: 'sides', v: 'front', l: o.front }, { cmd: 'sides', v: 'back', l: o.back }]);
    else if (asking === 'logo_text') this.chips([{ cmd: 'no-text', l: t.no_text }]);
    else this.chips([]);
    if (window.matchMedia('(min-width: 750px)').matches) this.replyField.focus({ preventScroll: true });
  };
  // Styles tendance : libellés traduits + vignettes, chargés une fois depuis l'API
  Studio.prototype.loadStyles = function () {
    var self = this;
    if (!this.stylesP) this.stylesP = fetch(addParam(this.endpoint, 'action=styles&locale=' + this.loc), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .catch(function () { self.stylesP = null; return { styles: [], ui: {} }; });
    return this.stylesP;
  };
  // Vignettes des styles proposés par Manu (ou de tous les styles), puis « Choisis pour moi » / « Voir tous les styles »
  Studio.prototype.showStyles = function (keys) {
    var self = this, run = this.run;
    this.busy = true;
    this.loadStyles().then(function (d) {
      if (run !== self.run) return;
      self.busy = false;
      var all = d.styles || [], ui = d.ui || {};
      var list = keys && keys.length ? all.filter(function (st) { return keys.indexOf(st.key) > -1; }) : all;
      if (!list.length) list = (keys || []).map(function (k) { return { key: k, label: k.charAt(0).toUpperCase() + k.slice(1), img: null }; });
      var html = '<ul class="ais-styles" role="list">' + list.map(function (st) {
        return '<li><button type="button" class="ais-style" data-act="pick-style" data-k="' + esc(st.key) + '" data-l="' + esc(st.label) + '">' +
          (st.img ? '<img src="' + esc(sized(st.img, 320)) + '" alt="" loading="lazy" width="160" height="160">' : '<span class="ais-style__ph" aria-hidden="true">' + esc(st.label.charAt(0)) + '</span>') +
          '<span class="ais-style__name">' + esc(st.label) + '</span></button></li>';
      }).join('') + '</ul>';
      var chips = [{ cmd: 'style-any', l: ui.any || 'OK', ghost: true }];
      if (keys && keys.length && all.length > list.length) chips.push({ cmd: 'style-all', l: ui.all || '+', ghost: true });
      (list.length ? self.bot(html, true) : Promise.resolve()).then(function () { self.s.pending = 'manu'; self.chips(chips); });
    });
  };
  Studio.prototype.facesToDraw = function () {
    var sd = this.s.sides || 'both';
    return sd === 'front' ? ['front'] : (sd === 'back' ? ['back'] : ['back', 'front']);
  };

  /* ---------- Manu dessine (vrai logo, une face après l'autre) ---------- */
  Studio.prototype.generateFaces = function (list, isRedo) {
    var self = this, s = this.s, t = this.t, run = this.run;
    this.quick.innerHTML = ''; s.pending = null;
    if (this.left() <= 0) {
      this.bot(esc(t.limit)).then(function () { if (s.faces.front || s.faces.back) self.showResult(); });
      return;
    }
    this.busy = true;
    this.startLoader(t['loading_' + list[0]], list.length);
    var made = {}, mock = !this.endpoint, chain = Promise.resolve();
    list.forEach(function (side, i) {
      chain = chain.then(function () {
        if (run !== self.run) return;
        self.loaderStep(t['loading_' + side], side, i);
        if (mock) return self.mockWait().then(function () { made[side] = { mock: true }; });
        // Le devant s'appuie sur le dos (même univers) quand le dos vient de Manu
        var back = made.back || (s.faces.back && !s.faces.back.own && !s.faces.back.mock ? s.faces.back : null);
        return self.apiLogo(side, side === 'front' && back ? back.src : null).then(function (url) {
          return trimPng(url).then(function (tr) { made[side] = { src: url, view: tr.png, w: tr.w, h: tr.h }; });
        }, function (e) {
          if (e && e.status === 501) { mock = true; return self.mockWait().then(function () { made[side] = { mock: true }; }); }
          throw e;
        });
      });
    });
    chain.then(function () {
      if (run !== self.run) return;
      self.stopLoader(); self.busy = false;
      store('aisRuns', (store('aisRuns') || 0) + 1); self.updateTokens();
      list.forEach(function (side) { s.faces[side] = made[side]; s.pos[side] = { x: 0.5, y: 0.5, k: 1 }; });
      if (!isRedo) FACES.forEach(function (f) { if (list.indexOf(f) === -1 && !(s.faces[f] && s.faces[f].own)) s.faces[f] = null; });
      s.edit = list.length > 1 ? 'front' : list[0];
      self.showResult();
    }, function (e) {
      if (run !== self.run) return;
      self.stopLoader(); self.busy = false;
      // Ce qui a déjà été dessiné est gardé
      Object.keys(made).forEach(function (side) { s.faces[side] = made[side]; });
      self.bot(esc(e && e.status === 429 ? t.limit : (e && e.status === 422 ? t.refused : t.error))).then(function () {
        if (s.faces.front || s.faces.back) self.showResult();
        else self.chips([{ cmd: 'retry', l: t.retry }]);
      });
    });
  };
  Studio.prototype.mockWait = function () { var r = this.reduce; return new Promise(function (ok) { setTimeout(ok, r ? 150 : 1400); }); };
  Studio.prototype.apiLogo = function (side, ref) {
    var s = this.s;
    var brief = { sport: s.sport, idea: s.idea, logo_text: s.noText ? null : s.logoText, style: s.style, goal: s.goal, place: side, front_desc: s.frontDesc, back_desc: s.backDesc, locale: this.loc };
    var ctrl = 'AbortController' in window ? new AbortController() : null;
    if (ctrl) setTimeout(function () { ctrl.abort(); }, 110000);
    return fetch(this.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'logo', side: side, brief: brief, ref: ref || undefined }), signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { if (!r.ok) { var e = new Error(r.status); e.status = r.status; throw e; } return r.json(); })
      .then(function (j) { if (!j || !j.image_url) throw new Error('empty'); return j.image_url; });
  };

  /* ---------- Résultat : aperçu devant + dos, éditeur, couleurs ---------- */
  Studio.prototype.showResult = function () {
    var self = this, s = this.s, t = this.t, own = s.path === 'own';
    this.bot(esc(own ? t.result_own : t.result_ready)).then(function () {
      return self.bot('<div class="ais-result ais-result--stack" data-result></div>', true);
    }).then(function (el) {
      self.resultEl = el.querySelector('[data-result]');
      self.renderResult();
      var spirit = s.path === 'story' ? self.sameSpirit() : '';
      return spirit ? self.bot(spirit, true) : null;
    }).then(function () {
      s.pending = 'result';
      self.replyField.placeholder = own ? t.composer_ph : t.retouch_ph;
      if (own) { self.chips([{ cmd: 'to-ai', l: t.own_ai, ghost: true }]); return; }
      var tw = t.tweaks || {};
      self.chips([
        { cmd: 'tweak', v: 'minimal', l: tw.minimal }, { cmd: 'tweak', v: 'funny', l: tw.funny }, { cmd: 'tweak', v: 'text', l: tw.text },
        { cmd: 'tweak', v: 'sides', l: tw.sides }
      ].filter(function (c) { return c.l && !(c.v === 'minimal' && s.style === 'minimal'); }));
    });
  };
  Studio.prototype.renderResult = function () {
    var el = this.resultEl; if (!el) return;
    var s = this.s, t = this.t, side = s.edit, face = s.faces[side], S = SIZES[side];
    var base = this.supportsFor(s.niche)[0] || { shape: 'tee', blank: '' };
    var tabs = FACES.map(function (f) {
      return '<button type="button" class="ais-tab" data-act="edit-face" data-v="' + f + '" aria-pressed="' + (f === side) + '">' + esc(t.places[f]) + '<span class="ais-tab__dot' + (s.faces[f] ? ' is-on' : '') + '" aria-hidden="true"></span></button>';
    }).join('');
    var zone = '<div class="ais-edit__zone" style="aspect-ratio:' + S[0] + ' / ' + S[1] + '" data-zone>' +
      (face ? '<img data-drag tabindex="0" role="img" aria-label="' + esc(t.edit_drag) + '" src="' + esc(face.view || this.mockPng(side)) + '" alt="" draggable="false">' : '<p class="ais-edit__empty">' + esc(t.edit_empty) + '</p>') + '</div>';
    var tools = face
      ? '<div class="ais-edit__tools"><label class="ais-edit__size"><span>' + esc(t.edit_size) + '</span><input type="range" min="25" max="100" step="1" value="' + Math.round(s.pos[side].k * 100) + '" data-size></label>' +
        '<button type="button" class="ais-chip" data-act="edit-center">' + esc(t.edit_center) + '</button>' +
        (face.own && !face.svg && !face.alpha ? '<button type="button" class="ais-chip" data-act="face-bg" aria-pressed="' + !!face.clean + '">' + esc(t.own_bg) + '</button>' : '') + '</div>' +
        '<p class="ais-note ais-edit__hint">' + esc(t.edit_drag) + '</p><p class="ais-note" data-quality></p>'
      : '';
    var files = '<div class="ais-edit__files"><label class="ais-btn ais-btn--ghost ais-btn--sm">' + IC.up + '<span>' + esc(face ? t.edit_replace : t.edit_upload) + '</span><input type="file" class="ais-vh" accept="image/png,image/jpeg,image/webp,image/svg+xml,.svg" data-face-file></label>' +
      (s.path === 'story' && s.idea ? '<button type="button" class="ais-btn ais-btn--ghost ais-btn--sm" data-act="face-redo">' + IC.redo + esc(face ? t.edit_redo : t.edit_create) + '</button>' : '') +
      (face ? '<button type="button" class="ais-btn ais-btn--ghost ais-btn--sm" data-act="face-clear">' + esc(t.edit_clear) + '</button>' : '') + '</div>';
    el.innerHTML = '<div data-mockbox>' + this.mock(base, s.color, true, true) + '</div>' +
      '<div class="ais-result__body"><div class="ais-edit"><div class="ais-tabs" role="group">' + tabs + '</div>' + zone + tools + files + '</div>' +
      this.swatches() +
      '<div class="ais-actions"><button type="button" class="ais-btn ais-btn--primary" data-act="keep">' + esc(t.keep) + IC.arrow + '</button></div>' +
      '<p class="ais-note">' + esc(t.mock_note) + '</p></div>';
    var img = el.querySelector('[data-drag]'); if (img) this.placeImg(img, side);
    this.refreshQuality();
  };
  Studio.prototype.placeImg = function (img, side) {
    var R = placeRect(this.s.faces[side], side, this.s.pos[side]);
    img.style.left = (R.x / R.W * 100) + '%'; img.style.top = (R.y / R.H * 100) + '%';
    img.style.width = (R.w / R.W * 100) + '%'; img.style.height = (R.h / R.H * 100) + '%';
  };
  Studio.prototype.refreshMock = function () {
    var box = this.resultEl && this.resultEl.querySelector('[data-mockbox]'); if (!box) return;
    var base = this.supportsFor(this.s.niche)[0] || { shape: 'tee', blank: '' };
    box.innerHTML = this.mock(base, this.s.color, true, true);
  };
  Studio.prototype.refreshQuality = function () {
    var q = this.resultEl && this.resultEl.querySelector('[data-quality]'); if (!q) return;
    var s = this.s, t = this.t, face = s.faces[s.edit];
    if (!face || face.mock) { q.textContent = ''; return; }
    if (face.svg) { q.textContent = t.own_vector; q.classList.remove('ais-own__q--low'); return; }
    var dpi = dpiOf(face, s.edit, s.pos[s.edit]);
    q.textContent = fmt(dpi >= 150 ? t.own_dpi_ok : t.own_dpi_low, { dpi: dpi });
    q.classList.toggle('ais-own__q--low', dpi < 150);
  };
  // Logos simulés (sans IA) : un PNG composé à la volée, pour l'éditeur et l'aperçu
  Studio.prototype.mockPng = function (side) {
    var s = this.s, key = side + '|' + s.idea + '|' + s.style + '|' + s.logoText;
    this.mockCache = this.mockCache || {};
    if (this.mockCache[key]) return this.mockCache[key];
    var W = side === 'back' ? 600 : 900, H = side === 'back' ? 640 : 380, c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d'), words = String(s.logoText || s.idea || 'RX').replace(/[«»"“”„]/g, '').split(/\s+/).filter(function (w) { return w.length > 2; }).slice(0, 3);
    x.fillStyle = '#c16452'; x.beginPath();
    if (side === 'back') x.arc(W / 2, H * 0.42, W * 0.32, 0, 7); else x.rect(W * 0.04, H * 0.18, H * 0.64, H * 0.64);
    x.fill();
    x.fillStyle = '#171717'; x.textAlign = 'center'; x.textBaseline = 'middle';
    var txt = (words[0] || 'RX').toUpperCase();
    x.font = '900 ' + (side === 'back' ? 92 : 110) + 'px Archivo Black, Arial Black, sans-serif';
    if (side === 'back') x.fillText(txt, W / 2, H * 0.86, W * 0.9); else { x.textAlign = 'left'; x.fillText(txt, H * 0.8, H / 2, W - H * 0.85); }
    return (this.mockCache[key] = c.toDataURL('image/png'));
  };
  // Designs signature du même sport, en petit sous le résultat
  Studio.prototype.sameSpirit = function () {
    var s = this.s, list = [], self = this;
    this.designs.forEach(function (d, i) { if (d.official && d.niche === s.niche) list.push(i); });
    if (!list.length) return '';
    var start = ((store('aisRuns') || 0) * 3) % list.length, pick = [];
    for (var k = 0; k < Math.min(3, list.length); k++) pick.push(list[(start + k) % list.length]);
    return '<div class="ais-spirit"><p class="ais-spirit__title">' + esc(this.t.same_spirit) + '</p><ul class="ais-mini" role="list">' + pick.map(function (i) {
      var d = self.designs[i];
      return '<li><button type="button" class="ais-mini__item" data-act="pick-design" data-i="' + i + '"><img src="' + esc(sized(d.img, 120)) + '" alt="" loading="lazy" width="44" height="44"><span>' + esc(d.t) + '</span></button></li>';
    }).join('') + '</ul></div>';
  };

  /* ---------- Fichiers du visiteur (une face) ---------- */
  Studio.prototype.ownFile = function (file, side, fromHero) {
    var self = this, t = this.t, isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
    if (fromHero || !this.dialog.open) this.open({ path: 'own', own: true });
    this.user(file.name);
    var fail = function (msg) { self.bot(esc(msg)).then(function () { if (!self.resultEl) self.chips([{ cmd: 'to-ai', l: t.own_ai, ghost: true }]); }); };
    if (!isSvg && !/^image\/(png|jpe?g|webp)$/i.test(file.type)) return fail(t.own_bad);
    if (file.size > 15 * 1024 * 1024) return fail(t.own_big);
    this.busy = true;
    this.startLoader(t.loading_own, 1); this.loaderStep(t.loading_own, side, 0);
    var job = isSvg
      ? readAs(file, 'readAsText').then(function (txt) {
          if (!/<svg[\s>]/i.test(txt) || /<script|\son\w+\s*=|<foreignObject/i.test(txt)) throw new Error('svg');
          var doc = new DOMParser().parseFromString(txt, 'image/svg+xml'), root = doc.documentElement;
          if (!root || root.nodeName.toLowerCase() !== 'svg') throw new Error('svg');
          var vb = root.getAttribute('viewBox');
          if (!vb) { var w = parseFloat(root.getAttribute('width')) || 100, h = parseFloat(root.getAttribute('height')) || 100; vb = '0 0 ' + w + ' ' + h; }
          return { own: true, name: file.name, svg: txt, vb: vb, inner: root.innerHTML, raw: 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(txt), alpha: true };
        })
      : readAs(file, 'readAsDataURL').then(function (url) { return hasAlpha(url).then(function (a) { return { own: true, name: file.name, raw: url, alpha: a, clean: !a }; }); });
    var run = this.run;
    job.then(function (face) { return self.prepOwn(face).then(function () { return face; }); }).then(function (face) {
      if (run !== self.run) return;
      self.stopLoader(); self.busy = false;
      self.s.faces[side] = face; self.s.pos[side] = { x: 0.5, y: 0.5, k: 1 }; self.s.edit = side;
      if (self.resultEl) { self.renderResult(); self.scroll(); }
      else self.showResult();
    }, function () { if (run !== self.run) return; self.stopLoader(); self.busy = false; fail(t.own_bad); });
  };
  // Image affichée et imprimée : fond retiré si demandé, recadrée au contenu
  Studio.prototype.prepOwn = function (f) {
    var base = f.svg || f.alpha || !f.clean ? Promise.resolve(f.raw) : (f.cleaned ? Promise.resolve(f.cleaned) : clearWhite(f.raw).then(function (u) { f.cleaned = u; return u; }));
    return base.then(function (src) { return trimPng(src).then(function (tr) { f.src = src; f.view = tr.png; f.w = tr.w; f.h = tr.h; }); });
  };

  /* ---------- Réponses du visiteur ---------- */
  Studio.prototype.command = function (cmd, value, label) {
    var s = this.s, t = this.t, self = this, o = t.sides_opts || {};
    this.user(label); this.quick.innerHTML = '';
    if (cmd === 'tag') { s.tag = value; this.showDesigns(); return; }
    if (cmd === 'sides') { s.sides = value; this.askManu(label); return; }
    if (cmd === 'no-text') { s.noText = true; s.logoText = null; this.askManu(label); return; }
    if (cmd === 'style-any') { this.lockThread(); this.askManu(label); return; }
    if (cmd === 'style-all') { this.lockThread(); this.showStyles(null); return; }
    if (cmd === 'retry') { this.generateFaces(this.facesToDraw()); return; }
    if (cmd === 'to-ai' || cmd === 'switch-path') { this.dialog.close(); this.toHero(); return; }
    if (cmd === 'change-design') { this.lockThread(); s.design = null; s.designOk = false; s.support = null; this.setStep('design'); if (s.path === 'design') this.showDesigns(); else this.showResult(); return; }
    if (cmd === 'change-support') { this.lockThread(); s.support = null; this.flow(); return; }
    if (cmd === 'no-text-redo') { s.noText = true; s.logoText = null; this.lockThread(); this.resultEl = null; this.generateFaces(this.facesToDraw()); return; }
    if (cmd === 'sides-redo') {
      s.sides = value;
      var want = this.facesToDraw(), need = want.filter(function (f) { return !s.faces[f]; });
      FACES.forEach(function (f) { if (want.indexOf(f) === -1) s.faces[f] = null; });
      this.lockThread(); this.resultEl = null;
      if (need.length) this.generateFaces(need, true); else this.showResult();
      return;
    }
    if (cmd === 'tweak') {
      if (value === 'text') { s.pending = 'new-text'; this.bot(esc(t.ask_new_text)).then(function () { self.chips([{ cmd: 'no-text-redo', l: t.no_text, ghost: true }]); }); return; }
      if (value === 'sides') { this.bot(esc(t.q_sides)).then(function () { self.chips([{ cmd: 'sides-redo', v: 'both', l: o.both }, { cmd: 'sides-redo', v: 'front', l: o.front }, { cmd: 'sides-redo', v: 'back', l: o.back }]); }); return; }
      if (value === 'minimal') s.style = 'minimal';
      else if (value === 'funny') s.idea = s.idea + ' ' + t.funny_suffix;
      this.lockThread(); this.resultEl = null;
      this.generateFaces(this.facesToDraw());
    }
  };
  Studio.prototype.freeText = function (text) {
    var s = this.s, t = this.t;
    this.user(text); this.quick.innerHTML = '';
    if (BLOCKED.test(text.toLowerCase())) { this.refuse(); return; }
    if (s.pending === 'idea' || ((s.path === 'story' || s.path === 'own') && !s.idea && !s.faces.front && !s.faces.back)) { s.idea = text; s.logoText = quotedText(text); s.path = 'story'; this.updateTokens(); this.askManu(text); return; }
    if (s.pending === 'manu') { this.askManu(text); return; }
    if (s.pending === 'new-text') { s.logoText = text.slice(0, 40); s.noText = false; this.lockThread(); this.resultEl = null; this.generateFaces(this.facesToDraw()); return; }
    if (s.pending === 'result') {
      if (!s.idea) { s.idea = text; s.path = 'story'; this.updateTokens(); }
      else s.idea = s.idea + ' ' + t.retouch_prefix + ' ' + text;
      // Retouche : la face citée seulement (« au dos… », « devant… »), sinon les faces prévues
      var x = text.toLowerCase(), only = /\bdos\b|\bback\b|espalda|r[uü]cken|retro|schiena/.test(x) ? ['back'] : (/devant|\bfront\b|delante|vorne|davanti|poitrine|chest/.test(x) ? ['front'] : null);
      if (only) { if (only[0] === 'back') s.backDesc = ((s.backDesc || '') + ' ' + text).trim(); else s.frontDesc = ((s.frontDesc || '') + ' ' + text).trim(); }
      this.lockThread(); this.resultEl = null;
      this.generateFaces(only || this.facesToDraw(), !!only);
    }
  };

  /* ---------- Déroulé (designs établis, vêtement, récapitulatif) ---------- */
  Studio.prototype.flow = function () {
    var s = this.s, t = this.t;
    if (s.path === 'design' && !s.design) return this.showDesigns();
    if (s.path === 'story' && !s.idea) { s.pending = 'idea'; return this.bot(esc(t.ask_idea)); }
    if (s.path !== 'design' && !s.designOk) return;
    this.setStep('support');
    if (s.path === 'design' && !s.support) return this.designChosen();
    if (!s.support) return this.showSupports();
    return this.summary();
  };
  Studio.prototype.supportsFor = function (niche) {
    return this.supports.filter(function (sp) { return sp.niche === niche || sp.niche === 'all'; });
  };
  Studio.prototype.styleTags = function () {
    var n = this.s.niche, seen = {}, out = [];
    this.designs.forEach(function (d) {
      if (d.niche !== n || !d.official) return;
      (d.tags || []).forEach(function (tg) { tg = String(tg).toLowerCase(); if (NICHE_TAGS.indexOf(tg) > -1 || seen[tg]) return; seen[tg] = 1; out.push(tg); });
    });
    return out.sort();
  };
  Studio.prototype.showDesigns = function () {
    var s = this.s, t = this.t, self = this, tag = s.tag || 'all';
    var list = [];
    this.designs.forEach(function (d, i) {
      if (!d.official || d.niche !== s.niche) return;
      if (tag !== 'all' && (d.tags || []).map(function (x) { return String(x).toLowerCase(); }).indexOf(tag) === -1) return;
      list.push([d, i]);
    });
    list = list.slice(0, 9);
    var html = '<ul class="ais-grid" role="list">' + list.map(function (p) {
      return '<li><button type="button" class="ais-pick" data-act="pick-design" data-i="' + p[1] + '"><span class="ais-pick__img"><img src="' + esc(sized(p[0].img, 360)) + '" alt="" loading="lazy" width="360" height="360"></span><span class="ais-pick__name">' + esc(p[0].t) + '</span></button></li>';
    }).join('') + '</ul>';
    s.pending = 'designs';
    var chips = [{ cmd: 'tag', v: 'all', l: t.all, on: tag === 'all' }].concat(this.styleTags().map(function (k) { return { cmd: 'tag', v: k, l: TAG_NAMES[k] || k, on: tag === k }; }));
    chips.push({ cmd: 'switch-path', v: 'story', l: t.own_ai, ghost: true });
    (tag === 'all' ? this.bot(esc(t.design_intro)) : Promise.resolve()).then(function () { return self.bot(html, true); }).then(function () { self.chips(chips); });
  };
  Studio.prototype.designChosen = function () {
    var s = this.s, t = this.t, self = this, d = s.design;
    var sp = this.supports.filter(function (x) { return x.h === d.p; })[0] || { h: d.p, t: '', price: '', url: d.url };
    var html = '<ul class="ais-supports" role="list"><li><button type="button" class="ais-support" data-act="pick-support-design">' +
      '<figure class="ais-mock"><img src="' + esc(sized(d.img, 600)) + '" alt=""></figure>' +
      '<span class="ais-support__meta"><span class="ais-support__name">' + esc(shortTitle(sp.t) || d.t) + '</span><span class="ais-support__price">' + esc(sp.price) + '</span></span></button></li></ul>';
    this.bot(esc(fmt(t.design_chosen, { t: d.t }))).then(function () { return self.bot(esc(t.support_design)); }).then(function () { return self.bot(html, true); }).then(function (el) {
      var b = el.querySelector('[data-act="pick-support-design"]');
      b.addEventListener('click', function () { if (self.busy) return; self.user(shortTitle(sp.t) || d.t); s.support = sp; self.lockThread(); b.disabled = true; self.flow(); }, { once: true });
      s.pending = null;
      self.chips([{ cmd: 'change-design', l: t.change_design, ghost: true }]);
    });
  };
  // Fichiers d'impression (SVG taille réelle, position et taille comprises) rangés pour la fiche produit
  Studio.prototype.saveFaces = function () {
    var s = this.s, self = this, at = Date.now(), out = {}, jobs = [];
    FACES.forEach(function (side) {
      var f = s.faces[side]; if (!f) return;
      var job = !f.mock ? Promise.resolve(f) : trimPng(self.mockPng(side)).then(function (tr) { return { src: tr.png, view: tr.png, w: tr.w, h: tr.h }; });
      jobs.push(job.then(function (ff) { out[side] = { svg: printSvg(ff, side, s.pos[side]), cm: SIZES[side], dpi: ff.svg ? null : dpiOf(ff, side, s.pos[side]) }; }));
    });
    return Promise.all(jobs).then(function () {
      s.logo = { at: at, sides: Object.keys(out) };
      return idbPut('logo', { v: 2, at: at, faces: out });
    }).catch(function () { s.logo = null; });
  };
  Studio.prototype.mainFace = function () { var f = this.s.faces; return f.back && !f.front ? 'back' : 'front'; };
  Studio.prototype.showSupports = function () {
    var t = this.t, s = this.s, self = this, list = [];
    this.supports.forEach(function (sp, i) { if (sp.niche === s.niche || sp.niche === 'all') list.push([sp, i]); });
    if (!list.length) { this.bot(esc(t.no_support)); return; }
    var html = '<ul class="ais-supports" role="list">' + list.map(function (p) {
      return '<li><button type="button" class="ais-support" data-act="pick-support" data-i="' + p[1] + '">' + self.mock(p[0], s.color, false, false) +
        '<span class="ais-support__meta"><span class="ais-support__name">' + esc(shortTitle(p[0].t)) + '</span><span class="ais-support__price">' + esc(p[0].price) + '</span></span></button></li>';
    }).join('') + '</ul>';
    this.bot(esc(t.support_ask)).then(function () { return self.bot(html, true); }).then(function () {
      s.pending = null;
      self.chips([{ cmd: 'change-design', l: t.change_design, ghost: true }]);
    });
  };
  Studio.prototype.summary = function () {
    var t = this.t, s = this.s, self = this, sp = s.support;
    this.setStep('custom');
    var visual = s.path === 'design' ? '<figure class="ais-mock"><img src="' + esc(sized(s.design.img, 700)) + '" alt=""></figure>' : this.mock(sp, s.color, false, true);
    var html = '<div class="ais-result' + (s.path !== 'design' ? ' ais-result--stack' : '') + '">' + visual +
      '<div class="ais-result__body"><p class="ais-result__title">' + esc(shortTitle(sp.t) || (s.design && s.design.t) || '') + '</p>' +
      (sp.price ? '<p class="ais-note">' + esc(sp.price) + '</p>' : '') +
      (s.path !== 'design' ? this.swatches() : '') +
      (s.path !== 'design' && s.logo ? '<p class="ais-note">' + esc(t.logo_ready_note) + '</p>' : '') +
      '<div class="ais-actions"><a class="ais-btn ais-btn--primary" href="' + esc(this.handoffUrl()) + '" data-act="handoff">' + esc(t.cta_custom) + IC.arrow + '</a></div>' +
      '<p class="ais-note">' + esc(t.mock_note) + '</p></div></div>';
    this.bot(esc(t.summary)).then(function () { return self.bot(html, true); }).then(function (el) {
      if (el && s.path === 'design') self.realRender(el.querySelector('.ais-result__body'), s.design);
      s.pending = null;
      self.chips([{ cmd: 'change-support', l: t.change_support, ghost: true }, { cmd: 'change-design', l: t.change_design, ghost: true }]);
    });
  };
  // Rendu réel Teeinblue d'un design signature (fichiers d'impression par emplacement), via /api/studio.
  // Sans endpoint, sans clé ou en cas d'erreur : rien ne s'affiche, l'aperçu galerie suffit.
  Studio.prototype.realRender = function (body, design) {
    var t = this.t, m = /customization-id=([0-9a-f-]{36})/i.exec(design && design.url || '');
    if (!this.endpoint || !m || !body || !window.fetch) return;
    var box = document.createElement('div');
    box.className = 'ais-real'; box.setAttribute('aria-busy', 'true');
    box.innerHTML = '<p class="ais-real__title">' + esc(t.real_title) + '</p><p class="ais-note">' + esc(t.real_loading) + '</p>';
    body.insertBefore(box, body.querySelector('.ais-actions'));
    fetch(addParam(this.endpoint, 'action=render&cid=' + encodeURIComponent(m[1])), { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) {
        var items = (j.designs || []).filter(function (d) { return d.thumbnail; }).slice(0, 2);
        if (!items.length) { box.remove(); return; }
        box.removeAttribute('aria-busy');
        box.innerHTML = '<p class="ais-real__title">' + esc(t.real_title) + '</p><ul class="ais-real__list" role="list">' + items.map(function (d) {
          var side = d.key && /back|dos|arri/i.test(d.key) ? t.sides.back : (d.key && /front|avant|devant/i.test(d.key) ? t.sides.front : (d.key || ''));
          return '<li><img src="' + esc(d.thumbnail) + '" alt="' + esc(side) + '" loading="lazy">' + (side ? '<span>' + esc(side) + '</span>' : '') + '</li>';
        }).join('') + '</ul><p class="ais-note">' + esc(t.real_note) + '</p>';
      })
      .catch(function () { box.remove(); });
  };
  Studio.prototype.handoffUrl = function () {
    var s = this.s;
    if (s.path === 'design' && s.design) return addParam(s.design.url, 'rx_studio=1');
    return addParam(s.support.url, 'rx_studio=1');
  };
  Studio.prototype.handoff = function () {
    var s = this.s;
    // Les images restent dans IndexedDB (trop lourdes pour sessionStorage) : ici seulement le brief
    store('rxStudioBrief', { v: 4, at: Date.now(), path: s.path, sport: s.sport, niche: s.niche, idea: s.idea, logo_text: s.logoText, style: s.style, goal: s.goal, sides: s.sides, color: s.color,
      logo: s.logo ? { at: s.logo.at, sides: s.logo.sides } : null, design: s.design ? s.design.url : null, support: s.support ? s.support.h : null });
  };

  /* ---------- Couleurs : celles des vêtements du sport (variantes Shopify) ---------- */
  Studio.prototype.palette = function () {
    var out = [], by = {};
    this.supportsFor(this.s.niche).forEach(function (sp) {
      (sp.colors || []).forEach(function (c) {
        var k = colorKey(c.n); if (!k) return;
        if (!by[k]) { by[k] = { k: k, n: c.n, h: c.h || '#cccccc', on: [] }; out.push(by[k]); }
        var nm = niceName(sp.t); if (by[k].on.indexOf(nm) === -1) by[k].on.push(nm);
      });
    });
    if (!out.length) out = [{ k: 'noir', n: this.t.color.black, h: '#000000', on: [] }, { k: 'blanc', n: this.t.color.white, h: '#ffffff', on: [] }];
    // Noir et blanc d'abord, puis les couleurs les plus répandues
    var rank = function (c) { return c.k === 'noir' || c.k === 'black' ? -2 : (c.k === 'blanc' || c.k === 'white' ? -1 : 0); };
    return out.sort(function (x, y) { return rank(x) - rank(y) || y.on.length - x.on.length; });
  };
  Studio.prototype.colorOf = function (k) {
    var pal = this.palette(), c = pal.filter(function (x) { return x.k === k; })[0];
    return c || pal[0];
  };
  Studio.prototype.availText = function (c) {
    var t = this.t, all = this.supportsFor(this.s.niche).length;
    if (!c.on.length) return '';
    return c.on.length >= all ? t.color_all : fmt(t.color_on, { list: c.on.join(', ') });
  };
  Studio.prototype.swatches = function () {
    var t = this.t, self = this, cur = this.colorOf(this.s.color);
    this.s.color = cur.k;
    return '<div class="ais-colors"><p class="ais-colors__label">' + esc(t.color_label) + ' <strong data-color-name>' + esc(cur.n) + '</strong></p>' +
      '<div class="ais-swatches" role="group" aria-label="' + esc(t.color_label) + '">' + this.palette().map(function (c) {
        return '<button type="button" class="ais-swatch" style="--sw:' + esc(c.h) + '" data-act="color" data-c="' + esc(c.k) + '" aria-pressed="' + (c.k === cur.k) + '" title="' + esc(c.n) + '"><span class="ais-vh">' + esc(c.n) + '</span></button>';
      }).join('') + '</div><p class="ais-colors__avail" data-color-avail>' + esc(self.availText(cur)) + '</p></div>';
  };
  Studio.prototype.setColor = function (k) {
    var self = this, c = this.colorOf(k);
    this.s.color = c.k;
    this.thread.querySelectorAll('[data-mock]').forEach(function (fig) {
      var sp = JSON.parse(fig.getAttribute('data-mock'));
      var tmp = document.createElement('div'); tmp.innerHTML = self.mock(sp, c.k, fig.hasAttribute('data-badge'), fig.hasAttribute('data-both'));
      fig.replaceWith(tmp.firstChild);
    });
    this.thread.querySelectorAll('.ais-swatch').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-c') === c.k ? 'true' : 'false'); });
    this.thread.querySelectorAll('[data-color-name]').forEach(function (el) { el.textContent = c.n; });
    this.thread.querySelectorAll('[data-color-avail]').forEach(function (el) { el.textContent = self.availText(c); });
  };

  /* ---------- Aperçu sur le vêtement : devant + dos (both) ou la face principale ---------- */
  Studio.prototype.mock = function (sp, color, badge, both) {
    var s = this.s, t = this.t, self = this, main = this.mainFace();
    var c = this.colorOf(color), has = !sp.colors || !sp.colors.length || sp.colors.some(function (x) { return colorKey(x.n) === c.k; });
    var g = garment(has ? c.h : '#000000');
    var data = esc(JSON.stringify({ shape: sp.shape, blank: sp.blank, zone: sp.zone, colors: sp.colors }));
    var anyMock = FACES.some(function (f) { return s.faces[f] && s.faces[f].mock; });
    var attrs = ' data-mock="' + data + '"' + (badge ? ' data-badge' : '') + (both ? ' data-both' : '');
    var extras = (badge && anyMock ? '<span class="ais-mock__badge">' + esc(t.preview_sim) + '</span>' : '') +
      (!both ? '<span class="ais-mock__side">' + esc(t.sides[main]) + '</span>' : '') +
      (!has ? '<span class="ais-mock__na">' + esc(fmt(t.color_na, { c: c.n })) + '</span>' : '');
    var sh = SHAPES[sp.shape] || SHAPES.tee;
    var face = function (side, dx) {
      var Sz = SIZES[side], zw = sh.zone[2], zh = zw * Sz[1] / Sz[0], zx = sh.zone[0], zy = sh.zone[1] + (side === 'front' ? 8 : 0);
      var collar = side === 'front' ? 'M174 60c10 8 42 8 52 0' : 'M172 56c12 4 44 4 56 0';
      var f = s.faces[side], inner;
      if (f) {
        var R = placeRect(f, side, s.pos[side]), k = zw / Sz[0], src = f.view || self.mockPng(side);
        inner = '<image href="' + esc(src) + '" x="' + (zx + R.x * k).toFixed(1) + '" y="' + (zy + R.y * k).toFixed(1) + '" width="' + (R.w * k).toFixed(1) + '" height="' + (R.h * k).toFixed(1) + '" preserveAspectRatio="none"/>';
      } else {
        inner = '<rect x="' + zx + '" y="' + zy + '" width="' + zw + '" height="' + zh.toFixed(1) + '" rx="4" fill="none" stroke="' + g.ink + '" stroke-opacity=".35" stroke-width="1.5" stroke-dasharray="6 6"/>';
      }
      return '<g transform="translate(' + dx + ' 0)">' +
        '<ellipse cx="200" cy="372" rx="120" ry="8" fill="#000" opacity=".08"/>' +
        '<path d="' + sh.d + '" fill="' + g.fill + '" stroke="' + g.line + '" stroke-width="2" stroke-linejoin="round"/>' +
        '<path d="' + collar + '" fill="none" stroke="' + g.collar + '" stroke-width="3"/>' + inner +
        (both ? '<text x="200" y="396" text-anchor="middle" font-family="Montserrat, sans-serif" font-size="13" font-weight="700" letter-spacing="2" fill="#6f6a5d">' + esc(t.sides[side].toUpperCase()) + '</text>' : '') + '</g>';
    };
    var svg = both
      ? '<svg viewBox="0 0 800 404" role="img" aria-label="' + esc(t.preview_sim) + '"><rect width="800" height="404" fill="#faf2e6"/>' + face('front', 0) + face('back', 400) + '</svg>'
      : '<svg viewBox="0 0 400 400" role="img" aria-label="' + esc(t.preview_sim) + '"><rect width="400" height="400" fill="#faf2e6"/>' + face(main, 0) + '</svg>';
    return '<figure class="ais-mock' + (both ? ' ais-mock--both' : '') + '"' + attrs + '>' + svg + extras + '</figure>';
  };

  /* ---------- Bouton flottant : retour au champ de l'accueil ---------- */
  Studio.prototype.setupLauncher = function () {
    var btn = this.root.querySelector('[data-ais-launcher]'), self = this;
    if (!btn || !('IntersectionObserver' in window)) return;
    btn.hidden = false; btn.setAttribute('data-off', '');
    btn.addEventListener('click', function () { self.toHero(); });
    var seen = false;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      if (e.isIntersecting) { seen = true; btn.setAttribute('data-off', ''); }
      else if (seen || e.boundingClientRect.bottom < 0) btn.removeAttribute('data-off');
      else btn.setAttribute('data-off', '');
    }, { threshold: 0 }).observe(this.root.querySelector('.ais__inner'));
  };

  function boot() { document.querySelectorAll('[data-ais]').forEach(function (el) { if (!el._ais) el._ais = new Studio(el); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
